<template>
    <div ref="top">
        <div class="mb-5">
            <h3>Thank You For Your Order!</h3>
            <p>The ACG Credit Card Services Team will review the request and provide approval within 3 business. Pending item availability, orders will be fulfilled and shipped out within 10 business days of order approval.</p>
        </div>
        <div class="mb-3">
            <h4>Contact Information</h4>
            <ul class="list-unstyled">
                <li>First Name: {{ order.first_name }}</li>
                <li>Last Name: {{ order.last_name }}</li>
                <li>Phone Number: {{ order.phone }}</li>
                <li>Email Address: {{ order.email }}</li>
                <li>Location ID: {{ order.location_id }}</li>
                <li>Location Address: {{ order.location_address }}</li>
                <li>Location City: {{ order.location_city }}</li>
                <li>Location State: {{ order.location_state }}</li>
                <li>Location Zip: {{ order.location_zip }}</li>
            </ul>
        </div>
        <div v-if="order.products" class="mb-3">
            <h4>Marketing Materials Requested</h4>
            <ul class="list-unstyled">
                <li v-for="product in order.products">{{ product.name }} ({{ product.pack_quantity }}/pack): {{ product.pivot.quantity }}</li>
            </ul>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        order: {
            type: Object,
            required: true
        }
    },
    mounted() {
        const el = this.$refs.top;

        if (el) {
            el.scrollIntoView({behavior: 'smooth'});
        }
    }
}
</script>
